import { Box, Chip, ClickAwayListener, InfoIcon, Link, Tooltip } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import React from "react"
import { DbgPaths } from "#/utils/Paths"
import { Link as RouterLink } from "react-router-dom"

export const DirectPayChip = (): React.ReactElement => {
  const [open, setOpen] = React.useState(false)
  const handleTooltipClose = () => {
    setOpen(false)
  }
  const handleTooltipOpen = () => {
    setOpen(!open)
  }

  return (
    <Box data-tooltip-id="direct-pay-chip">
      <ClickAwayListener onClickAway={handleTooltipClose}>
        <Tooltip
          open={open}
          disableTouchListener
          title={
            <FormattedMessage
              defaultMessage="Providers that participate in Direct Pay can bill Carrot directly for services covered by your available Carrot funds. <link>Learn more in your benefit guide.</link>"
              values={{
                link: (linkContent) => (
                  <Link to={DbgPaths.DIRECT_PAY} component={RouterLink} color="inherit" fontSize="inherit">
                    {linkContent}
                  </Link>
                )
              }}
            />
          }
        >
          <Chip
            size="small"
            label={
              <Box display="flex" flexDirection="row" alignItems="center">
                <FormattedMessage defaultMessage="Bills Carrot directly" />
                &nbsp;
                <InfoIcon color="inherit" fontSize="inherit" />
              </Box>
            }
            onClick={handleTooltipOpen}
            color="info"
          />
        </Tooltip>
      </ClickAwayListener>
    </Box>
  )
}
